import { BaseSyntheticEvent } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { selectedGames, selectedGamesSelectors } from '@bg-shared/business/SelectedGames';
import { Betting } from '@bg-shared/contexts/Betting';
import { useMobileView } from '@bg-shared/hooks/useMobileView';
import { BettingOptionStatus } from '@bg-shared/enums/BettingOptionStatus';
import { IFormattedBettingOption } from '@bg-shared/interfaces/IBettingOption';
import { mapBettingOptionToSelectedModel } from '@bg-shared/business/SelectedGames/utils/mapBettingOptionToSelectedModel';

interface IUseScreenBettingOption {
    active: boolean;
    disabled: boolean;
    isActiveStatus: boolean;
    onBettingOptionClick: (event: BaseSyntheticEvent) => void;
}

export const useScreenBettingOption = (
    bettingOption: IFormattedBettingOption,
    openForBets: boolean,
    trackBettingOptionClick: () => void,
): IUseScreenBettingOption => {
    const bettingOptionsIds = useStore(selectedGames.store, selectedGamesSelectors.getOptionsIds);
    const processing = Betting.useProcessing();
    const setOpen = Betting.useSetOpenBetslip();
    const fromBottom = Betting.useFromBottom();
    const isMobile = useMobileView();
    const isActiveStatus = bettingOption.status === BettingOptionStatus.ACTIVE;
    const disabled = !isActiveStatus || !openForBets || processing;

    const onBettingOptionClick = (event: BaseSyntheticEvent): void => {
        event.stopPropagation();

        if (disabled) {
            return;
        }

        trackBettingOptionClick();

        selectedGames.store.add(mapBettingOptionToSelectedModel(bettingOption));

        if (isMobile) {
            setOpen(true, fromBottom);
        }
    };

    return {
        active: bettingOptionsIds.includes(Number(bettingOption.id)),
        disabled,
        isActiveStatus,
        onBettingOptionClick,
    };
};
